import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { LoadingPane } from '../../common';
import { tenantHelpers } from '../../tenantInfo';
import '../../common/paged-list.scss';
import { Link } from 'react-router-dom';
import * as unregisteredParticipantsActions from './unregistered-participants.actions';

export class RegistrationSummaryComponent extends Component {
  renderDataRow(account){
    return(
      <tr key={account.externalId}>
        <td>{account.firstName}</td>
        <td>{account.lastName}</td>
        <td>{account.email}</td>
      </tr>
    );
  }

  render() {
    const { unregisteredParticipants } = this.props;
    const { registrationState } = unregisteredParticipants;
    const { err, isFetching, data: registrationResults } = registrationState;

    const successResults = !!registrationResults && !!registrationResults.successResults ? registrationResults.successResults : [];
    const errorResults = !!registrationResults && !!registrationResults.errorResults ? registrationResults.errorResults : [];

    const tableHeaders =
      <thead>
        <tr>
          <th>First Name</th><th>Last Name</th><th>Email</th>
        </tr>
      </thead>;

    // account created
    const successResultsMessage = successResults.length > 1 ?
      <p id="success-msg">{successResults.length} new {tenantHelpers.getProductName()} accounts were created for the following participants. Each will receive an email with a link allowing them to create a password and log in.</p> :
      successResults.length === 1 ?
        <p id="success-msg">1 new {tenantHelpers.getProductName()} account was created for the following participant. They will receive an email with a link allowing them to create a password and log in.</p> :
        null;
    const successResultsTable = successResults.length > 0 ?
      <div>
        <table id="summary-table-successes" className="table table-striped">
          {tableHeaders}
          <tbody>
            {successResults.map(res => (this.renderDataRow(res)))}
          </tbody>
        </table>
        <br/>
      </div> :
      null;

    // account creation failed
    const failureSummaryMessage = errorResults.length > 0 ?
      <p id="failure-summary-msg">{tenantHelpers.getProductName()} accounts could not be created for {errorResults.length} selected participants.</p> :
      null;
    const accountExistsResults = [];
    const invalidEmailResults = [];
    for(var i=0; i<errorResults.length; i++){
      switch (errorResults[i].type) {
        case 'duplicate':
          accountExistsResults.push(errorResults[i].data);
          break;
        case 'email':
        default:
          invalidEmailResults.push(errorResults[i].data);
          break;
      }
    }
    // account creation failed - already exists
    const accountExistsMessage = accountExistsResults.length > 0 ?
      <p id="failure-duplicate-msg">{tenantHelpers.getProductName()} accounts already exist for these participants' email address:</p> :
      null;
    const accountExistsTable = accountExistsResults.length > 0 ?
      <table id="summary-table-failures-duplicates" className="table table-striped">
        {tableHeaders}
        <tbody>
          {accountExistsResults.map(res => (this.renderDataRow(res)))}
        </tbody>
      </table> :
      null;

    // account creation failed - invalid email
    const invalidEmailMessage = invalidEmailResults.length > 0 ?
      <p id="failure-email-msg">The following participants do not have a valid email address, which is required for {tenantHelpers.getProductName()} access:</p> :
      null;
    const invalidEmailTable = invalidEmailResults.length > 0 ?
      <table id="summary-table-failures-emails" className="table table-striped">
        {tableHeaders}
        <tbody>
          {invalidEmailResults.map(res => (this.renderDataRow(res)))}
        </tbody>
      </table> :
      null;

    return(
      <div className="registration-summary">
        <h1>Registration Results</h1>
        <LoadingPane id='alias' isLoading={isFetching} err={err} loadingMessage="Loading Registration Results...">
          {successResultsMessage}
          {successResultsTable}
          <br/>
          {failureSummaryMessage}
          {accountExistsMessage}
          {accountExistsTable}
          {invalidEmailMessage}
          {invalidEmailTable}
        </LoadingPane>
        <div>
          <Link to={{pathname : '/unregistered', state : { focusElement: 'participant-types-tab-content'}}} role="presentation" aria-label="close">
            <button className="btn btn-primary" type="button">Close</button>
          </Link>
        </div>
      </div>
    );
  }
}

RegistrationSummaryComponent.propTypes = {
};

const mapStateToProps = ({ unregisteredParticipants }) => {
  return {
    unregisteredParticipants
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    unregisteredParticipantsActions: bindActionCreators(unregisteredParticipantsActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationSummaryComponent);
